import { ReactComponent as Facebook } from '../../assets/fb-icon.svg';
import { ReactComponent as Instagram } from '../../assets/insta-icon.svg';
import { ReactComponent as Tiktok } from '../../assets/TikTok-icon.svg';
import { ReactComponent as Twitter } from '../../assets/twitter-icon.svg';
import { ReactComponent as Youtube } from '../../assets/yt-icon.svg';

export const Socials = ({ classNames, facebookUrl, instagramUrl, tikTokUrl, twitterUrl, youtubeUrl }) => (
    <div className={classNames}>
        {facebookUrl && (
            <a href={facebookUrl} target="_blank" rel="noopener noreferrer">
                <Facebook />
            </a>
        )}
        {instagramUrl && (
            <a href={instagramUrl} target="_blank" rel="noopener noreferrer">
                <Instagram />
            </a>
        )}
        {twitterUrl && (
            <a href={twitterUrl} target="_blank" rel="noopener noreferrer">
                <Twitter />
            </a>
        )}
        {tikTokUrl && (
            <a href={tikTokUrl} target="_blank" rel="noopener noreferrer">
                <Tiktok />
            </a>
        )}
        {youtubeUrl && (
            <a href={youtubeUrl} target="_blank" rel="noopener noreferrer">
                <Youtube />
            </a>
        )}
    </div>
);
